import React, { useState, useEffect } from 'react'
import Edit from "../../assets/edit.png"
import Trash from "../../assets/trash.png"
import Link from "../../assets/link.png"
import Eye from "../../assets/eye.png"

const DynamicTable = (props) => {
    const {
        columns = [],
        data = [],
        onNew,
        headerText,
        onEdit,
        onDelete,
        onLink,
        onSearch,
        onPageChange,
        onWatch,
        emptySearch,
        totalRows = 0, // Total de filas que pasas como prop
        entriesPerPage = 5, // Registros por página (valor por defecto)
        onEditPHX
    } = props

    const [pagination, setPagination] = useState({
        currentPage: 1,
        entriesPerPage, // Inicializa con el valor de entriesPerPage
    })

    const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda

    useEffect(() => {
        // Resetear la página actual si cambia el total de filas
        setPagination((prev) => ({
            ...prev,
            currentPage: 1,
        }))
    }, [totalRows])

    const totalPages = Math.ceil(totalRows / pagination.entriesPerPage)

    const goToPage = (page) => {
        setPagination((prev) => ({
            ...prev,
            currentPage: page,
        }))
        if (onPageChange) {
            onPageChange(page, pagination.entriesPerPage) // Enviar también el tamaño de página
        }
    }

    const prev = () => {
        if (pagination.currentPage > 1) {
            goToPage(pagination.currentPage - 1)
        }
    }

    const next = () => {
        if (pagination.currentPage < totalPages) {
            goToPage(pagination.currentPage + 1)
        }
    }

    const handleInputChange = (e) => {
        setSearchTerm(e)
        if (e === "") {
            onSearch('')
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            onSearch(searchTerm);
        }
    }

    const startIndex = (pagination.currentPage - 1) * pagination.entriesPerPage

    return (
        <div className="card">
            <div className="card-body">

                <div className="d-flex justify-content-between align-items-center mb-3">

                    <select
                        className="form-control col-md-1"
                        aria-label="Rows per page"
                        value={pagination.entriesPerPage} // Mantener el valor en el estado
                        onChange={(e) => {
                            const newEntriesPerPage = Number(e.target.value)
                            setPagination((prev) => ({
                                ...prev,
                                entriesPerPage: newEntriesPerPage,
                                // NO reiniciar a la primera página
                                currentPage: Math.min(prev.currentPage, Math.ceil(totalRows / newEntriesPerPage)), // Mantener la página actual si es válida
                            }))
                            if (onPageChange) {
                                onPageChange(pagination.currentPage, newEntriesPerPage) // Llamar a la función de cambio de página
                            }
                        }}
                    >
                        {[5, 10, 15, 20].map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                    <div className="input-group col-md-6">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar por nombre"
                            value={searchTerm}
                            onChange={(e) => handleInputChange(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <button className="btn btn-primary" onClick={(e) => onSearch(searchTerm)}>
                            <i className="fas fa-search"></i>
                        </button>
                    </div>

                    {onNew && headerText && (
                        <button className="btn btn-primary" onClick={onNew}>
                            <i className="fas fa-plus"></i> {headerText}
                        </button>
                    )}
                </div>

                {/* Tabla */}
                <div className="table-responsive">
                    <table className="table custom-table">
                        <thead>
                            <tr className="text-left">
                                {columns.map((column, index) => (
                                    <th key={index}>{column}</th>
                                ))}
                                {(onEdit || onDelete || onLink || onWatch || onEditPHX) && <th>Acción</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((item, rowIndex) => (
                                    <tr key={rowIndex} className="text-left">
                                        {columns.map((column, colIndex) => (
                                            <td key={colIndex}>
                                                {column === 'Estado' ? (
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                item[column] === 'Activo'
                                                                    ? 'lightgreen'
                                                                    : 'lightgray',
                                                            padding: '5px',
                                                            borderRadius: '5px',
                                                        }}
                                                    >
                                                        {item[column]}
                                                    </span>
                                                ) : (
                                                    item[column]
                                                )}
                                            </td>
                                        ))}
                                        {(onEdit || onDelete || onLink || onWatch || onEditPHX) && (
                                            <td>
                                                <div className="d-flex justify-content-left">
                                                    {onEdit && (
                                                        <button
                                                            className="btn btn-link text-dark p-0 mx-2"
                                                            title="Editar"
                                                            onClick={() => onEdit(item)}
                                                        >
                                                            <img src={Edit} alt="Edit" style={{ width: '20px', height: '20px' }} />
                                                        </button>
                                                    )}
                                                    {onEditPHX && (
                                                        <button
                                                        className="btn btn-link text-dark p-0 mx-2"
                                                            title="Ver"
                                                            onClick={() => onEditPHX(item)}
                                                        >
                                                            <img
                                                                src={Eye}
                                                                alt="watch"
                                                                style={{ width: '20px', height: '20px' }}
                                                            />
                                                        </button>
                                                    )}
                                                    {onDelete && (
                                                        <button
                                                            className="btn btn-link text-dark p-0 mx-2"
                                                            title="Eliminar"
                                                            onClick={() => onDelete(item)}
                                                        >
                                                            <img
                                                                src={Trash}
                                                                alt="Eliminar"
                                                                style={{ width: '20px', height: '20px' }}
                                                            />
                                                        </button>
                                                    )}
                                                    {onLink && (
                                                        <button
                                                            className="btn btn-link text-dark p-0 mx-2"
                                                            title="Asociar tableros"
                                                            onClick={() => onLink(item)}
                                                        >
                                                            <img
                                                                src={Link}
                                                                alt="Link"
                                                                style={{ width: '20px', height: '20px' }}
                                                            />
                                                        </button>
                                                    )}
                                                    {onWatch && (
                                                        <button
                                                            className="btn btn-link text-dark p-0 mx-2"
                                                            title="Ver"
                                                            onClick={() => onWatch(item)}
                                                        >
                                                            <img
                                                                src={Eye}
                                                                alt="watch"
                                                                style={{ width: '20px', height: '20px' }}
                                                            />
                                                        </button>
                                                    )}
                                                    {/*onWatch && (
                                                        <button
                                                            className="btn btn-link text-dark p-0 mx-2"
                                                            title="Ver"
                                                            onClick={() => onWatch(item)}
                                                        >
                                                            <img
                                                                src={Eye}
                                                                alt="watch"
                                                                style={{ width: '20px', height: '20px' }}
                                                            />
                                                        </button>
                                                    )*/}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length + 1} className="text-center">
                                        No hay datos disponibles.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                    <span>
                        Mostrando {startIndex + 1} a {Math.min(startIndex + pagination.entriesPerPage, totalRows)} de {totalRows} registros
                    </span>
                    <div className="ms-auto">
                        <button className="btn btn-light" disabled={pagination.currentPage === 1} onClick={prev}>
                            Anterior
                        </button>
                        {/* Paginación con puntos suspensivos */}
                        {totalPages <= 10 ? (
                            Array.from({ length: totalPages }, (_, index) => (
                                <button
                                    key={index}
                                    className={`btn ${index + 1 === pagination.currentPage ? 'btn-primary' : 'btn-light'}`}
                                    onClick={() => goToPage(index + 1)}
                                >
                                    {index + 1}
                                </button>
                            ))
                        ) : (
                            <>
                                {pagination.currentPage > 5 && (
                                    <>
                                        <button className="btn btn-light" onClick={() => goToPage(1)}>1</button>
                                        <span className="btn btn-light">...</span>
                                    </>
                                )}
                                {Array.from({ length: 5 }, (_, index) => {
                                    const page = pagination.currentPage - 2 + index
                                    return page > 0 && page <= totalPages ? (
                                        <button
                                            key={page}
                                            className={`btn ${page === pagination.currentPage ? 'btn-primary' : 'btn-light'}`}
                                            onClick={() => goToPage(page)}
                                        >
                                            {page}
                                        </button>
                                    ) : null
                                })}
                                {pagination.currentPage < totalPages - 4 && (
                                    <>
                                        <span className="btn btn-light">...</span>
                                        <button className="btn btn-light" onClick={() => goToPage(totalPages)}>{totalPages}</button>
                                    </>
                                )}
                            </>
                        )}
                        <button className="btn btn-light" disabled={pagination.currentPage === totalPages} onClick={next}>
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DynamicTable
